import { VariantProps, cva } from 'class-variance-authority';
import { FC } from 'react';

interface BadgeProps extends VariantProps<typeof badgeStyles> {
  /**
   * Represents the label text to be displayed in the Badge component.
   */
  label: string;
}

const badgeStyles = cva('w-fit rounded-2xl border px-3 py-1 font-spaceGrotesk text-sm font-medium', {
  variants: {
    color: {
      gray: 'border-white/20 bg-white/10 text-white',
      teal: 'border-primary-300 bg-gray-900/80 text-white',
      light: 'border-primary-1000 text-primary-1000',
      green: 'border-primary-1000 bg-primary-1400 text-gray-900',
    },
  },
});

const Badge: FC<BadgeProps> = ({ label, color }) => <div className={badgeStyles({ color })}>{label}</div>;

export default Badge;
